import { DropdownGroup } from './DropdownGroup';
import { InputDataTypeMaxMin } from './InputDataTypeMaxMin';
import { EventTypeInputRating } from './EventTypeInputRating';
import { InputDataTypeEnum } from '../../enums/inputDataTypeEnum';
import { EventTypeInputReg } from './EventTypeInputReg';
import { SelectOption } from './SelectOption';

export class EventTypeInput {
    constructor(
        eventTypeInputId: number,
        eventTypeId: number,
        inputDataTypeId: InputDataTypeEnum,
        inputHeading: string,
        mandatory: boolean,
        inputMandatory: boolean,
        dropdownGroup: DropdownGroup | null,
        inputDataTypeMaxMin: InputDataTypeMaxMin | null,
        inputOrder: number,
        deleted: boolean,
        eventTypeInputRating: EventTypeInputRating | null,
        eventTypeInputReg: EventTypeInputReg | null,
        isEmpty: boolean,
        isValid: boolean
    ) {
        this.eventTypeInputId = eventTypeInputId;
        this.eventTypeId = eventTypeId;
        this.inputDataTypeId = inputDataTypeId;
        this.inputHeading = inputHeading;
        this.mandatory = mandatory;
        this.inputMandatory = inputMandatory;
        this.dropdownGroup = dropdownGroup;
        this.inputDataTypeMaxMin = inputDataTypeMaxMin;
        this.inputOrder = inputOrder;
        this.deleted = deleted;
        this.eventTypeInputRating = eventTypeInputRating;
        this.eventTypeInputReg = eventTypeInputReg;
        this.optModel = [];
        this.optionsModel = [];
        this.isEmpty = isEmpty;
        this.isValid = isValid;
    }
    eventTypeInputId: number;
    eventTypeId: number;
    inputDataTypeId: InputDataTypeEnum;
    inputHeading: string;
    mandatory: boolean;
    dropdownGroup: DropdownGroup | null;
    inputDataTypeMaxMin: InputDataTypeMaxMin | null;
    inputOrder: number;
    deleted: boolean;
    eventTypeInputRating: EventTypeInputRating | null;
    eventTypeInputReg: EventTypeInputReg | null;
    optionsModel: number[];
    optModel: SelectOption[];
    inputMandatory: boolean;
    isEmpty: boolean;
    isValid: boolean;
}
